import { AddBox, Delete, Edit } from "@mui/icons-material";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react"
import axiosInstance from "../../../utils/axiosInstance";

const Guests = () => {
    const [guests, setGuests] = useState([
        {
            guest_id: 0,
            name: '',
            email: '',
            phone: '',
            createdAt: '',
        }
    ]);
    const [guest, setGuest] = useState({
        guest_id: 0,
        name: '',
        email: '',
        phone: '',
        password: '',
    });
    const [selectedGuest, setSelectedGuest] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const getGuestsRef = useRef();

    const filteredGuests = guests.filter((user) =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedGuests = filteredGuests.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        console.log(event)
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Delete confirmation handlers
    const handleOpenDeleteModal = (user) => {
        setSelectedGuest(user);
        setIsDeleteModalOpen(true);
    };

    const handleOpenEditModal = (user) => {
        setSelectedGuest(user);
        setIsEditModalOpen(true);
    };

    const handleDeleteUser = async () => {
        setOpen(true)
        
        await axiosInstance.delete(`guests/delete/${selectedGuest.guest_id}`).then((response) => {
            setMessage(`Success, successfully deleted ${selectedGuest.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getGuestsRef.current) getGuestsRef.current();
                setIsDeleteModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                setMessage("No guests found")
            } else if(error.status === 400) {
                setMessage(error.response.error)
            } else {
                console.log(error)
            }

            setTimeout(() => {
                setOpen(false)
            }, 2000)
        })
    }

    const handleEditGuest = async() => {
        setOpen(true);

        await axiosInstance.put(`guests/update/${selectedGuest.guest_id}`, selectedGuest).then((response) => {
            setMessage(`Success, successfully edited ${selectedGuest.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getGuestsRef.current) getGuestsRef.current();
                setIsEditModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.status === 404) {
                setMessage(`Failure, guest not found`)
            } else if(error.status === 400) {
                setMessage(`Failure, ${error.response.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000)
        })
    }

    const handleAddGuest = async() => {
        setOpen(true);

        await axiosInstance.post(`guests/create`, guest, {
                headers: { 'Content-Type': 'application/json' }
            }).then((response) => {
            setMessage(`Success, successfully added ${guest.name}`)
            setTimeout(() => {
                setOpen(false);
                if(getGuestsRef.current) getGuestsRef.current();
                setIsAddModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            console.log(error.response.data)
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    useEffect(() => {
        const getGuests = async () => {
            await axiosInstance.get(`guests/all`).then((response) => {
                setGuests(response.data.guests);
            }).catch((error) => {
                if(error.response && error.response.data.message === "No guests found") {
                    setGuests([]);
                } else if(error.response && error.response.data.message !== "No guests found") {
                    setGuests([]);
                    // console.error(error.response.data)
                } else {
                    setGuests([]);
                    // console.log(error);
                }
            });
        }

        getGuestsRef.current = getGuests;

        getGuests()
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Manage guest</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add Member</Button></div>
            </div>
            <br />

            <div className="p-4">
                <TextField label="Search for a guest by name, email" variant="outlined" fullWidth value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                <TableContainer component={Paper} className="shadow mt-4" sx={{ color: "#1f2937" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Registered on</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedGuests.map((guest, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index+1}</TableCell>
                                    <TableCell>{guest.name}</TableCell>
                                    <TableCell>{guest.email}</TableCell>
                                    <TableCell>{guest.phone}</TableCell>
                                    <TableCell>{guest.createdAt.slice(0,10)}</TableCell>
                                    {/* <TableCell>{dateFormat(guest.created_at)}</TableCell> */}
                                    <TableCell className="flex gap-2">
                                        {/* <RemoveRedEye color="success" className="cursor-pointer" /> */}
                                        <Edit color="primary" onClick={() => handleOpenEditModal(guest)} className="cursor-pointer" />
                                        <Delete color="error" onClick={() => handleOpenDeleteModal(guest)} className="cursor-pointer" />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {filteredGuests.length === 0 && <TableRow><TableCell colSpan={7} className="text-center">No guest found.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, filteredGuests.length ]}
                        component="div"
                        count={filteredGuests.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>

            {/* Delete Confirmation Modal */}
            <Dialog open={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)}>
                <DialogTitle className="text-blue-950">Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the guest named "
                        {selectedGuest.name ? selectedGuest.name : "Anonymus"}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDeleteModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteUser} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Guest Modal */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Edit Guest {selectedGuest.name}</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={selectedGuest.name} onChange={(e) => setSelectedGuest((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Enter name" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedGuest.email} onChange={(e) => setSelectedGuest((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Enter email" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={selectedGuest.phone} onChange={(e) => setSelectedGuest((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Enter phone" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsEditModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleEditGuest}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Add Guest Modal */}
            <Modal open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} className="flex justify-center items-center" aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className="text-blue-950 mb-8">Add Guest</h2>
                    <div>
                        <TextField variant="outlined" fullWidth value={guest.name} onChange={(e) => setGuest((prev) => ({ ...prev, name: e.target.value }))} type="text" label="Enter name" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={guest.email} onChange={(e) => setGuest((prev) => ({ ...prev, email: e.target.value }))} type="email" label="Enter email" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={guest.phone} onChange={(e) => setGuest((prev) => ({ ...prev, phone: e.target.value }))} type="tel" label="Enter phone" style={{ marginBottom: 10 }} />
                        <TextField variant="outlined" fullWidth value={guest.password} onChange={(e) => setGuest((prev) => ({ ...prev, password: e.target.value }))} type="password" label="Enter password" style={{ marginBottom: 10 }} />
                    </div>
                    <div className="flex items-center justify-center gap-8 w-[90%] mx-auto mt-4">
                        <Button onClick={() => setIsAddModalOpen(false)} color="secondary" variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button color="primary" variant="outlined" fullWidth onClick={handleAddGuest}>
                            Save
                        </Button>
                    </div>
                </div>
            </Modal>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    )
}

export default Guests